import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import {
  AccordionSummary,
  Box,
  Card,
  Container,
  Grid,
  Icon,
  Typography,
} from '@material-ui/core';
import { Row } from 'components/Row';
import { CustomButton } from 'components/CustomButton';
import {
  createAditivoDescentralizadoRoute,
  createDistratoDescentralizadoRoute,
  modelosDocumentosContratoRoute,
} from 'library/Routes';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import {
  loadContratoAssessor,
  openModalAditivo,
  openModalDistrato,
} from 'store/modules/ContratosFluxoDescentralizado/Assessores/AssessoresActions';
import { useEffect, useState } from 'react';
import {
  CONTRATO_ETAPAS_PARAMS_URL,
  CONTRATO_PASSOS,
  CONTRATO_FLUXO_DESCENTRALIZADO,
  URL_ADITIVO_PARAM,
  URL_DISTRATO_PARAM,
  URL_ENTE_DESCENTRALIZADO,
  TipoFluxo,
  TipoContrato,
  VersaoContratoEnum,
} from 'models/contratos';
import ControlledAccordions from 'pages/Contratos/components/Accordion';
import { CreateRouteParams, EditRouteParams } from '../../__types';
import { loadContratoAdendos, resetFiltersDocumento } from 'store/modules/AllContratos/AllContratosActions';
import '../../index.scss'

export const DocumentoAssessorDescentralizado = () => {
  const [tipoFluxoFilter, setTipoFluxoFilter] = useState<number | null>(null);
  const [tipoEnteFilter, setTipoEnteFilter] = useState<number | null>(null);
  const languageValues = useSelector(
    (states: RootState) => states.languages.languageValues
  );
  const contratoAssessoresReducer = useSelector(
    (state: RootState) => state.contratosDescentralizadosAssessores
  );
  const adendoAll = useSelector(
    (state: RootState) => state.allContratos.adendosAll
  );
  const adendoObject = useSelector(
    (state: RootState) => state.allContratos.adendoObject
  );
  const programasFilter =
    contratoAssessoresReducer.contratoEditing.programasEducacionais;
  const params = useParams<CreateRouteParams & EditRouteParams>();
  const id = params.id || null;
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const fluxoAssessor = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ASSESSOR);

  useEffect(() => {
    const { pathname } = location;
    switch (true) {
      case pathname.includes(URL_ADITIVO_PARAM.CADASTRO_ADITIVO):
      case pathname.includes(URL_ADITIVO_PARAM.MODAL_EDICAO_ADITIVO):
        dispatch(openModalAditivo());
        break;
      case pathname.includes(URL_DISTRATO_PARAM.CADASTRO_DISTRATO):
      case pathname.includes(URL_DISTRATO_PARAM.MODAL_EDICAO_DISTRATO):
        dispatch(openModalDistrato());
        break;
      default:
        break;
    }
  }, [
    dispatch,
    location,
    location.pathname,
    params.idAditivo,
    params.idDistrato,
  ]);

  useEffect(() => {
    if (id) {
      dispatch(loadContratoAdendos(Number(id)));
    }
  }, [dispatch, id]);

  useEffect(() => {
    dispatch(resetFiltersDocumento());
    const urlAtual = window.location.href;

    const isEnteAssessor = () => {
      return urlAtual.includes(URL_ENTE_DESCENTRALIZADO.ASSESSOR) &&
        !urlAtual.includes(URL_ADITIVO_PARAM.EDICAO_ADITIVO) &&
        !urlAtual.includes(URL_ADITIVO_PARAM.CADASTRO_ADITIVO) &&
        !urlAtual.includes(URL_DISTRATO_PARAM.EDICAO_DISTRATO) &&
        !urlAtual.includes(URL_DISTRATO_PARAM.CADASTRO_DISTRATO);
    };
    if (isEnteAssessor() && fluxoAssessor) {
      setTipoFluxoFilter(TipoFluxo.DESCENTRALIZADO);
      setTipoEnteFilter(TipoContrato.ASSESSOR);
      dispatch(loadContratoAssessor(Number(id), VersaoContratoEnum.CONTRATO));
    }
  }, [dispatch, fluxoAssessor, id]);

  const handleDocumentoParams = () => {
    const filters = {
      tipoFluxo: tipoFluxoFilter,
      tipoContrato: tipoEnteFilter,
      programa: programasFilter,
    };
    localStorage.setItem('documentoFiltersAssessor', JSON.stringify(filters));
    const url = `${modelosDocumentosContratoRoute.path}?busca=true`;
    window.open(url, '_blank');
  };

  return (
    <>
      <Container className='componentsDescentralizado__container'>
        <Box className='componentsDescentralizado__box'>
          <Typography
            variant='h5'
            className='componentsDescentralizado__title'
          >
            {languageValues.documentos}
          </Typography>
          <Typography
            variant='h6'
            className='componentsDescentralizado__sub'
          >
            {languageValues.facaDownloadEUploadContrato}
          </Typography>
        </Box>
      </Container>

      <Card className='componentsDescentralizado__card'>
        <AccordionSummary
          className='componentsDescentralizado__accordionSummary'
          expandIcon={<Icon style={{ color: '#FFFFFF' }} />}
        >
          <Grid container spacing={1}>
            <Grid item xs={4} md={4}>
              <Typography className='componentsDescentralizado__accordionSummary-column-title'>
                {languageValues.cadastroContratoCodigo}
              </Typography>
            </Grid>
            <Grid item xs={3} md={3}>
              <Typography className='componentsDescentralizado__accordionSummary-column-title'>
                {languageValues.cadastroContratoVersao}
              </Typography>
            </Grid>
            <Grid item xs={3} md={3}>
              <Typography className='componentsDescentralizado__accordionSummary-column-title'>
                {languageValues.cadastroContratoSituacao}
              </Typography>
            </Grid>
            <Grid item xs={1} md={1}>
              <Typography className='componentsDescentralizado__accordionSummary-column-title'></Typography>
            </Grid>
            <Grid item xs={1} md={1}>
              <Typography className='componentsDescentralizado__accordionSummary-column-title color-actions'>
                {languageValues.cadastroContratoAcoes}
              </Typography>
            </Grid>
          </Grid>
        </AccordionSummary>
        <Box>
          <Typography
            variant='h6'
            className='componentsDescentralizado__adendos-title'
          ></Typography>
          {adendoAll.map((adendo) => (
            <ControlledAccordions
              key={adendo.id}
              id={adendo.id}
              ativo={adendo.ativo}
              codigo={adendo.codigo}
              flgStatus={adendo.flgStatus}
              idDocAssinado={adendo.idDocAssinado}
              idDocPlanoTrabalho={adendo.idDocPlanoTrabalho}
              idDocExtrato={adendo.idDocExtrato}
              dataAlteracao={adendo.dataAlteracao}
              versaoContrato={adendo.versaoContrato}
              incluiPlanoTrabalho={adendo.incluiPlanoTrabalho}
            />
          ))}
        </Box>
        <Box>
          <Row>
            <Grid
              container
              spacing={1}
              className='componentsDescentralizado__container-button-route'
            >
              <Grid item>
                <CustomButton
                  theme='pufvYellow'
                  className={'button-route__modelos-documentos'}
                  label={'Modelos de documentos'}
                  disabled={false}
                  onClick={() => {
                    handleDocumentoParams();
                  }}
                />
              </Grid>
              <Grid item>
                <CustomButton
                  theme='pufvYellow'
                  className={'button-route__criar-distrato'}
                  label={'Criar distrato'}
                  onClick={() => {
                    history.push(
                      createDistratoDescentralizadoRoute.getURLWithParams(
                        CONTRATO_FLUXO_DESCENTRALIZADO.ASSESSOR,
                        CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
                        id,
                        CONTRATO_PASSOS.DOCUMENTOS
                      )
                    );
                    dispatch(openModalDistrato());
                  }}
                  disabled={!adendoObject.geraDistrato}
                />
              </Grid>
              <Grid item>
                <CustomButton
                  theme='pufvYellow'
                  className={'button-route__criar-aditivo'}
                  label={'Criar aditivo'}
                  onClick={() => {
                    history.push(
                      createAditivoDescentralizadoRoute.getURLWithParams(
                        CONTRATO_FLUXO_DESCENTRALIZADO.ASSESSOR,
                        CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
                        id,
                        CONTRATO_PASSOS.DOCUMENTOS
                      )
                    );
                    dispatch(openModalAditivo());
                  }}
                  disabled={!adendoObject.geraAditivo}
                />
              </Grid>
            </Grid>
          </Row>
        </Box>
      </Card>
    </>
  );
};
